export { default } from './GridAttributes.vue'
